export default {
  title: 'Modificar disponibilidad',
  amend_availabilities_form: {
    date: {
      label: 'Seleccionar una fecha',
    },
    times: {
      label: 'Turnos y horarios de apertura',
      description:
        'Define los horarios de apertura para la fecha seleccionada. Amplía, reduce o bloquea tus turnos. Al menos un turno debe estar abierto.',
      breakfast: {
        label: 'Desayuno',
      },
      lunch: {
        label: 'Almuerzo',
      },
      dinner: {
        label: 'Cena',
      },
    },
  },
  reason: {
    label: 'Añadir un motivo (opcional)',
    placeholder: 'Introducir descripción...',
  },
  buttons: {
    save: 'Guardar',
  },
  projects: {
    online_shop: 'Tienda online',
    reservations: 'Reservas',
    storefront: 'Storefront',
  },
  error_messages: {
    creation_failed: 'Error al crear la excepción',
  },
};
